import { fetchQuoteProductClassesList } from '@views/screens/Quote/data-provider/quote-product-classes-list';
import { useQuery } from '@tanstack/react-query';

export const useGetQuoteProductClassesList = () => {
  return useQuery({
    queryFn: () => fetchQuoteProductClassesList(),
    queryKey: ['quote-product-classes-list'],
    staleTime: Number.POSITIVE_INFINITY,
  });
};
